import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-65cc932e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "upsell-after-cancel-modal__text mb-3" }, " Ваши ученики, материалы и история занятий по-прежнему доступны в Finch. ", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "upsell-after-cancel-modal__text mb-3" }, " Если вы вернулись к работе или планируете новый набор учеников, подключите нужные функции и продолжайте работу в привычном формате. ", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "upsell-after-cancel-modal__accent" }, [
  /*#__PURE__*/_createElementVNode("ul", { class: "upsell-after-cancel-modal__list" }, [
    /*#__PURE__*/_createElementVNode("li", null, "проводите уроки со звонками"),
    /*#__PURE__*/_createElementVNode("li", null, "работайте на онлайн-доске"),
    /*#__PURE__*/_createElementVNode("li", null, "добавляйте любое количество учеников")
  ])
], -1))

import { ref } from 'vue';
import TariffNotificationModal from '../TariffNotificationModal.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'UpsellAfterCancelModal',
  emits: ["hidden", "confirm"],
  setup(__props, { expose: __expose, emit: __emit }) {

const modalRef = ref<InstanceType<typeof TariffNotificationModal>>();

const emit = __emit;

function onConfirm() {
    emit('confirm');
}

function showModal() {
    modalRef.value?.show();
}

function hideModal() {
    modalRef.value?.hide();
}

__expose({
    show: showModal,
    hide: hideModal,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TariffNotificationModal, {
    ref_key: "modalRef",
    ref: modalRef,
    title: "Вернитесь к работе в Finch",
    onButtonClick: onConfirm,
    onHidden: _cache[0] || (_cache[0] = ($event: any) => (emit('hidden'))),
    "button-text": "Подробнее",
    "max-width": 450
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _hoisted_2,
      _hoisted_3
    ]),
    _: 1
  }, 512))
}
}

})